import { isDev } from '@/hooks/is-dev';
import { Alert, Menu, ActionIcon, Modal, Box } from '@mantine/core';
import { use, useState } from 'react';
import { LoansContext } from '@/context/loans-context-definition';
import { ParsingResults } from '@/components/results/loan-overview/parsing-results';
import { PlanSummaryDebugger } from '@/components/results/plan-summary-debugger';
import { PlanSummaryTable } from '@/components/results/plan-summary/plan-summary-table';
import { IconBug } from '@tabler/icons-react';
import { EligibilityDebugger } from '@/components/results/eligibility-debugger';
// import type { AllPlansResult } from '@/types/loanCalculationTypes';
// import type { LoanPlanDetails } from '@/types/planSummaryTypes';

type DebugComponent = 'plan' | 'results' | 'eligibility' | 'planSummary';

export function ResultsStep() {
  const isDevelopment = isDev();
  const context = use(LoansContext);
  const [modalOpened, setModalOpened] = useState(false);
  const [selectedDebugComponent, setSelectedDebugComponent] = useState<DebugComponent | null>(null);

  const openModal = (componentType: DebugComponent) => {
    setSelectedDebugComponent(componentType);
    setModalOpened(true);
  };

  if (!context) {
    return <Alert color="red">Loan context is not available.</Alert>;
  }

  const {
    // isMobile,
    // scenarioResults,
    scenarioPlanSummaries,
    scenarioCalculationError,
    scenarioCalculationLoading,
    // filteredLoans,
    surveyData,
    isMobile,
  } = context;

  // let displayedPlanDetails: LoanPlanDetails[] | null = null;
  // if (scenarioResults) {
  //   displayedPlanDetails = scenarioResults
  //     .map((result: AllPlansResult) => {
  //       const loan = filteredLoans.find((l) => l['Loan Award ID'] === result.loanAwardId);
  //       if (!loan) return null;

  //       return {
  //         loanAwardId: result.loanAwardId,
  //         loanDescription: result.loanDescription,
  //         borrower: result.borrower,
  //         results: result.results,
  //         eligibilityCriteria: result.eligibilityCriteria,
  //       };
  //     })
  //     .filter((detail): detail is NonNullable<typeof detail> => detail !== null);
  // }

  return (
    <Box h="100%" w="100%" style={{ minHeight: '680px' }}>
      {isDevelopment && (
        <Menu>
          <Menu.Target>
            <ActionIcon
              variant="filled"
              color="green"
              style={{ position: 'fixed', bottom: 15, left: 15, zIndex: 1000 }}
            >
              <IconBug />
            </ActionIcon>
          </Menu.Target>
          <Menu.Dropdown>
            <Menu.Label>Debug Views</Menu.Label>
            <Menu.Item
              onClick={() => {
                openModal('results');
              }}
            >
              NSLDS parsing
            </Menu.Item>
            <Menu.Item
              onClick={() => {
                openModal('eligibility');
              }}
            >
              Eligibility
            </Menu.Item>
            <Menu.Item
              onClick={() => {
                openModal('planSummary');
              }}
            >
              Payments
            </Menu.Item>
          </Menu.Dropdown>
        </Menu>
      )}

      <Modal
        opened={modalOpened}
        onClose={() => {
          setModalOpened(false);
        }}
        fullScreen
        title="Debug View"
      >
        {selectedDebugComponent === 'results' && <ParsingResults />}
        {selectedDebugComponent === 'eligibility' && <EligibilityDebugger />}
        {selectedDebugComponent === 'planSummary' && <PlanSummaryDebugger />}
      </Modal>

      <PlanSummaryTable
        // planDetails={displayedPlanDetails}
        allPlanSummaries={scenarioPlanSummaries}
        isLoading={scenarioCalculationLoading}
        error={scenarioCalculationError}
        showPartnerTabPredicate={surveyData?.includePartner ?? false}
        surveyData={surveyData}
        isMobile={isMobile}
      />
    </Box>
  );
}
